import React from "react";
import cx from "classnames";
import styles from "./common.module.scss";

/** A single animated shimmer block. Size/shape come from `className`. */
export const Shimmer: React.FC<{ className?: string; style?: React.CSSProperties }> = ({
  className,
  style,
}) => <span className={cx(styles.shimmer, className)} style={style} />;

interface TableSkeletonProps {
  columns: number;
  rows?: number;
  gridTemplate?: string;
  minWidth?: number | string;
}

/** Shimmer placeholder that mirrors the analytics table head + rows layout. */
export const TableSkeleton: React.FC<TableSkeletonProps> = ({
  columns,
  rows = 6,
  gridTemplate,
  minWidth,
}) => {
  const template = gridTemplate ?? `repeat(${columns}, 1fr)`;
  const rowStyle: React.CSSProperties = {
    gridTemplateColumns: template,
    minWidth: typeof minWidth === "number" ? `${minWidth}px` : minWidth,
  };

  return (
    <div className={styles.tableShimmer}>
      <div className={styles.tableHeadRow} style={rowStyle}>
        {Array.from({ length: columns }).map((_, i) => (
          <Shimmer key={i} className={styles.tableShimmerCell} style={{ width: "50%" }} />
        ))}
      </div>
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} className={styles.tableRow} style={rowStyle}>
          {Array.from({ length: columns }).map((_, c) => (
            <Shimmer key={c} className={styles.tableShimmerCell} />
          ))}
        </div>
      ))}
    </div>
  );
};

export const LoadingState: React.FC<{ style?: React.CSSProperties }> = ({ style }) => (
  <div className={styles.stateMessage} style={style}>
    Loading...
  </div>
);

export const EmptyState: React.FC<{ message?: string; style?: React.CSSProperties }> = ({
  message = "No data for the given filters.",
  style,
}) => (
  <div className={styles.stateMessage} style={style}>
    {message}
  </div>
);
